module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/add-files-29b2e15117c83afdceb2cf93109acb7d.svg";